export default __webpack_public_path__ + "static/media/checkpoint1.9af18ec9.txt";